<template>
    <div class="row" v-if="can('rbac.user', 'R')">
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-cash" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.cash_amount)}}</span></h5>
            <h6>Total Cash Amount</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash1 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-building-bank" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.bank_amount)}}</span></h5>
            <h6>Total Bank Amount</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash2 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-arrow-up" style="font-size: 32px; color: #4caf50;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{ netIncome }}</span></h5>
            <h6>Net Income</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash3 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-arrow-down" style="font-size: 32px; color: #f44336;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.expense_amount)}}</span></h5>
            <h6>Total Expense Amount</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash3 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-wallet" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.pos_receivable_amount)}}</span></h5>
            <h6>Total Pos Receivable Amount</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash3 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-file-percent" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.vat_payable)}}</span></h5>
            <h6>Total Vat Payable Amount</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash3 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-file-invoice" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{formatMoney(dashboard.supplier_bill_payable_amount)}}</span></h5>
            <h6>Total Supplier Bill Payable Amount</h6>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-widget dash3 w-100">
          <div class="dash-widgetimg">
            <span><i class="ti ti-trending-up" style="font-size: 32px;"></i></span>
          </div>
          <div class="dash-widgetcontent">
            <h5><span class="counters" >৳{{netProfit}}</span></h5>
            <h6>Net Profit</h6>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-count">
          <div class="dash-counts">
            <h4>{{ dashboardStats.total_customers }}</h4>
            <h5>Customers</h5>
          </div>
          <div class="dash-imgs">
            <i class="ti ti-users" style="font-size: 32px;"></i>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-count das1">
          <div class="dash-counts">
            <h4>{{ dashboardStats.total_suppliers }}</h4>
            <h5>Suppliers</h5>
          </div>
          <div class="dash-imgs">
            <i class="ti ti-user-check" style="font-size: 32px;"></i>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-count das2">
          <div class="dash-counts">
            <h4>{{ dashboardStats.total_purchase_invoice }}</h4>
            <h5>Purchase Invoice</h5>
          </div>
          <div class="dash-imgs">
            <i class="ti ti-shopping-bag" style="font-size: 32px;"></i>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12 d-flex">
        <div class="dash-count das3">
          <div class="dash-counts">
            <h4>৳{{formatMoney(dashboard.discount_amount)}}</h4>
            <h5>Discount Amount</h5>
          </div>
          <div class="dash-imgs">
            <i class="ti ti-discount" style="font-size: 32px;"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <div class="row">
      <div class="col-xl-7 col-sm-12 col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Purchase & Sales</h5>
            <div class="graph-sets">
              <ul class="mb-0">
                <li>
                  <span>Sales</span>
                </li>
                <li>
                  <span>Purchase</span>
                </li>
              </ul>
              <div class="dropdown dropdown-wraper">
                <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                  {{ selectedYear }}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item" @click="changeYear(2026)">2026</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item" @click="changeYear(2025)">2025</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item" @click="changeYear(2024)">2024</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <canvas id="sales_charts"></canvas>
          </div>
        </div>
      </div>
      <div class="col-xl-5 col-sm-12 col-12 d-flex">
        <div class="card flex-fill default-cover mb-4">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">Recent Products</h4>
            <div class="view-all-link">
<!--              <a href="javascript:void(0);" class="view-all d-flex align-items-center">-->
<!--                View All<span class="ps-2 d-flex align-items-center"><i data-feather="arrow-right" class="feather-16"></i></span>-->
<!--              </a>-->
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive dataview">
              <table class="table dashboard-recent-products">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Products</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in recentItems" :key="item.id">
                    <td>{{ index + 1 }}</td>

                    <td class="productimgname d-flex align-items-center">
                      <img
                        :src="$getImageUrl(item.images)"
                        alt="Items"
                        style="width:40px; height:40px; object-fit:cover;"
                      />

                      <span class="ms-2">
                        <strong>{{ item.item_name }}</strong>
                      </span>
                    </td>

                    <td>
                      <strong>{{ item.selling_price }}</strong>
                    </td>
                  </tr>

                  <!-- Empty state -->
                  <tr v-if="recentItems.length === 0">
                    <td colspan="3" class="text-center">No recent products</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Expired Products</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive dataview">
          <table class="table dashboard-expired-products">
            <thead>
              <tr>
                <th>Product</th>
                <th>SKU</th>
                <th>Manufactured Date</th>
                <th>Expired Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in expiredItems" :key="item.id">
                <td>
                  <div class="productimgname d-flex align-items-center">
                    <img
                      :src="$getImageUrl(item.images)"
                      alt="Items"
                      style="width:40px; height:40px; object-fit:cover;"
                    />

                    <span class="ms-2">
                      <strong>{{ item.item_name }}</strong>
                    </span>
                  </div>
                </td>

                <!-- SKU -->
                <td>
                  <span><strong>{{ item.sku || '-' }}</strong></span>
                </td>

                <!-- Manufacturing Date -->
                <td>
                  <strong>{{ formatDate(item.manufacturing_date) }}</strong>
                </td>

                <!-- Expire Date -->
                <td>
                  <strong>{{ formatDate(item.expire_date) }}</strong>
                </td>
              </tr>

              <!-- Empty state -->
              <tr v-if="expiredItems.length === 0">
                <td colspan="6" class="text-center">
                  No expired products
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import apiUrls from '@/urls';
import Chart from 'chart.js/auto';

export default {
  inject: ["globalLoading"],

  data() {
    return {
      dashboard: {
        cash_amount: 0.00,
        bank_amount: 0.00,
        income_amount: 0.00,
        expense_amount: 0.00,
        pos_receivable_amount: 0.00,
        vat_payable: 0.00,
        supplier_bill_payable_amount: 0.00,
        discount_amount: 0.00,
      },
      dashboardStats: {
        total_customers: 0,
        total_suppliers: 0,
        total_purchase_invoice: 0,
      },
      recentItems: [],
      expiredItems: [],
      chart: null,
      selectedYear: new Date().getFullYear(),
    };
  },

  mounted() {
    this.fetchCashAmount();
    this.fetchBankAmount();
    this.fetchIncomeAmount();
    this.fetchExpenseAmount();
    this.fetchPosReceivableAmount();
    this.fetchVatPayableAmount();
    this.fetchSupplierBillPayableAmount();
    this.fetchDiscountAmount();
    this.fetchDashboardStats();
    this.fetchRecentItems();
    this.fetchExpiredItems();
    this.fetchChartData();
  },

  computed: {
    profitAmount() {
      const income = parseFloat(this.dashboard.income_amount || 0);
      const expense = parseFloat(this.dashboard.expense_amount || 0);
      return (income - expense).toFixed(2);
    },

    netIncome() {
      const income = parseFloat(this.dashboard.income_amount || 0);
      const discount = parseFloat(this.dashboard.discount_amount || 0);
      return (income - discount).toFixed(2);
    },

    netProfit() {
      const profit = parseFloat(this.profitAmount || 0);
      const discount = parseFloat(this.dashboard.discount_amount || 0);
      return (profit - discount).toFixed(2);
    },
  },

  methods: {
    formatMoney(value) {
      return Number(value || 0).toFixed(2);
    },

    can(code, requiredLevel) {
      const perms = JSON.parse(localStorage.getItem("permissions")) || {};
      const userLevel = perms[code] || 'N';

      for (const char of requiredLevel) {
        if (!userLevel.includes(char)) {
          return false;
        }
      }
      return true;
    },

    async fetchCashAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.cash_amount.get);
        this.dashboard.cash_amount = response.data?.cash_amount ?? 0 ;
      } catch (error) {
        console.error("Error fetching cash amount:", error);
        this.dashboard.cash_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchBankAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.bank_amount.get);
        this.dashboard.bank_amount = response.data?.bank_amount ?? 0 ;
      } catch (error) {
        console.error("Error fetching bank amount:", error);
        this.dashboard.bank_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchIncomeAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.income_amount.get);
        this.dashboard.income_amount = response.data?.income_amount ?? 0 ;
      } catch (error) {
        console.error("Error fetching income amount:", error);
        this.dashboard.income_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchExpenseAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.expense_amount.get);
        this.dashboard.expense_amount = response.data?.expense_amount ?? 0 ;
      } catch (error) {
        console.error("Error fetching expense amount:", error);
        this.dashboard.expense_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchDiscountAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.discount_amount.get);
        this.dashboard.discount_amount = response.data?.discount_amount ?? 0 ;
      } catch (error) {
        console.error("Error fetching discount amount:", error);
        this.dashboard.discount_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchPosReceivableAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.pos_receivable_amount.get);
        this.dashboard.pos_receivable_amount = response.data?.pos_receivable ?? 0 ;
      } catch (error) {
        console.error("Error fetching pos receivable amount:", error);
        this.dashboard.pos_receivable_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchVatPayableAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.vat_payable_amount.get);
        this.dashboard.vat_payable = response.data?.vat_payable ?? 0 ;
      } catch (error) {
        console.error("Error fetching vat payable amount:", error);
        this.dashboard.vat_payable = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchSupplierBillPayableAmount() {
      this.globalLoading(true);

      try {
        const response = await this.$axios.get(apiUrls.supplier_bill_payable_amount.get);
        this.dashboard.supplier_bill_payable_amount = response.data?.supplier_bill_payable ?? 0 ;
      } catch (error) {
        console.error("Error fetching supplier bill payable amount:", error);
        this.dashboard.supplier_bill_payable_amount = 0;
      } finally {
        this.globalLoading(false);
      }
    },

    async fetchDashboardStats() {
      try {
        const res = await this.$axios.get(apiUrls.dashboard_data.get);
        this.dashboardStats = res.data;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchRecentItems() {
      try {
        const res = await this.$axios.get(apiUrls.recent_item.get);
        this.recentItems = res.data;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchExpiredItems() {
      try {
        const res = await this.$axios.get(apiUrls.expire_item.get);
        this.expiredItems = res.data;
      } catch (err) {
        console.error(err);
      }
    },

    formatDate(date) {
      if (!date) return '-';

      const d = new Date(date);

      if (isNaN(d)) return '-';

      return d.toLocaleDateString('en-GB');
    },

    async fetchChartData() {
      try {
        const res = await this.$axios.get(apiUrls.chart_data.get, {
          params: {
            year: this.selectedYear
          }
        });

        this.renderChart(res.data);
      } catch (e) {
        console.error(e);
      }
    },

    renderChart(apiData) {
      if (!apiData) return;

      const ctx = document.getElementById('sales_charts');

      if (!ctx) return;

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: apiData.months || [],
          datasets: [
            {
              label: 'Sales',
              data: apiData.sales || [],
              borderColor: '#28C76F',
              backgroundColor: 'rgba(40,199,111,0.2)',
              tension: 0.4,
              fill: true
            },
            {
              label: 'Purchase',
              data: apiData.purchase || [],
              borderColor: '#EA5455',
              backgroundColor: 'rgba(234,84,85,0.2)',
              tension: 0.4,
              fill: true
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
    },

    changeYear(year) {
      this.selectedYear = year;
      this.fetchChartData();
    },

  }
};

</script>
